module.exports = __webpack_public_path__ + "img/Report.4117a98f.gif";